import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAccountHierarchyWidget as GetAccountHierarchyWidgetQuery,
    AccountForCoreEntityFragment as Account,
    GetAccountHierarchyWidgetVariables,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_HIERARCHY_WIDGET from '../queries/get-account-hierarchy-widget.graphql';

export function useGetAccountHierarchyWidget(
    accountId: string,
    skip: boolean = false
): {
    currentAccount: Account | null;
    parentAccount: Account | null;
    childAccounts: Account[] | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetAccountHierarchyWidgetQuery,
        GetAccountHierarchyWidgetVariables
    >(GET_ACCOUNT_HIERARCHY_WIDGET, {
        variables: {id: accountId},
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        currentAccount: data?.account ?? null,
        parentAccount: data?.account?.parentAccount ?? null,
        childAccounts: data?.account?.childAccounts?.edges.map((edge) => edge.node) ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
